/**
 * Custom pages for bed visualizer.
 * - name: Name of the step
 * - limit: Sets the number of products that can be added in this step
 * - collection: Collection handle for the step
 * - stackOrders: z-indices of the visualizer images to control layering. Some
 *  step support 2 images at different layers so we need to provide 2
 *  stack orders
 */

 module.exports = [
  {
    name: 'Headboard',
    limit: 1,
    stackOrders: [1],
    tag: 'bed-visualizer:headboard',
  },
  {
    name: 'Bedding',
    limit: 1,
    stackOrders: [4, 8],
    tag: 'bed-visualizer:bedding',
  },
  {
    name: 'Sheet Set',
    limit: 1,
    stackOrders: [7, 3],
    tag: 'bed-visualizer:sheet-set',
  },
  {
    name: 'Decorative Pillows',
    limit: 3,
    stackOrders: [9],
    tag: 'bed-visualizer:decorative-pillow',
  },
  {
    name: 'Accent Pillow',
    limit: 1,
    stackOrders: [10],
    tag: 'bed-visualizer:accent-pillow',
  },
  /*{
    name: 'Euro Pillow',
    limit: 1,
    stackOrders: [2],
    tag: 'bed-visualizer:euro-pillow',
  },*/
  {
    name: 'Throw Blanket',
    limit: 1,
    stackOrders: [11],
    tag: 'bed-visualizer:throw-blanket',
  },
]